/* eslint-disable */
import React, { useState } from 'react';
// Feather Icons (Fi) - Recommandé
import {
  FiEdit2, FiTrash2, FiRefreshCw, FiXCircle, FiCheck, FiPlus, FiMinus,
  FiUser, FiUsers, FiBook, FiMessageCircle, FiMail, FiSettings, FiLogOut,
  FiHome, FiSearch, FiFilter, FiDownload, FiUpload, FiEye, FiEyeOff,
  FiLock, FiUnlock, FiKey, FiCalendar, FiClock, FiBell, FiStar,
  FiHeart, FiThumbsUp, FiThumbsDown, FiShare2, FiCopy, FiSave,
  FiFile, FiFolder, FiImage, FiVideo, FiMusic, FiPrinter, FiWifi,
  FiSmartphone, FiTablet, FiMonitor, FiServer, FiDatabase, FiCloud,
  FiArrowLeft, FiArrowRight, FiArrowUp, FiArrowDown, FiChevronLeft,
  FiChevronRight, FiChevronUp, FiChevronDown, FiMoreHorizontal,
  FiMoreVertical, FiMenu, FiX, FiCheckCircle, FiAlertCircle,
  FiInfo, FiHelpCircle, FiAlertTriangle, FiActivity, FiTrendingUp,
  FiTrendingDown, FiBarChart2, FiPieChart, FiCreditCard, FiDollarSign,
  FiShoppingCart, FiShoppingBag, FiTag, FiPercent, FiAward,
  FiTarget, FiFlag, FiMapPin, FiMap, FiNavigation, FiCompass,
  FiGlobe, FiLink, FiExternalLink, FiAtSign, FiHash, FiCode,
  FiTerminal, FiGitBranch, FiZap
} from 'react-icons/fi';
// Font Awesome Icons (Fa)
import {
  FaUser, FaUsers, FaEdit, FaTrash, FaPlus, FaMinus, FaSearch,
  FaHome, FaCog, FaSignOutAlt, FaBook, FaEnvelope, FaComment,
  FaCalendarAlt, FaClock, FaBell, FaStar, FaHeart, FaThumbsUp,
  FaThumbsDown, FaShare, FaCopy, FaSave, FaFile, FaFolder,
  FaImage, FaVideo, FaMusic, FaPrint, FaDownload, FaUpload,
  FaEye, FaEyeSlash, FaLock, FaUnlock, FaKey, FaWifi, FaMobile,
  FaTablet, FaDesktop, FaServer, FaDatabase, FaCloud
} from 'react-icons/fa';
// Material Design Icons (Md)
import {
  MdEdit, MdDelete, MdAdd, MdRemove, MdSearch, MdHome, MdSettings,
  MdExitToApp, MdBook, MdEmail, MdMessage, MdCalendarToday,
  MdAccessTime, MdNotifications, MdStar, MdFavorite, MdThumbUp,
  MdThumbDown, MdShare, MdContentCopy, MdSave, MdInsertDriveFile,
  MdFolder, MdImage, MdVideoLibrary, MdMusicNote, MdPrint,
  MdGetApp, MdFileUpload, MdVisibility, MdVisibilityOff,
  MdLock, MdLockOpen, MdVpnKey, MdWifi, MdPhoneAndroid,
  MdTablet, MdComputer, MdStorage, MdCloudQueue
} from 'react-icons/md';
// Ant Design Icons (Ai)
import {
  AiOutlineEdit, AiOutlineDelete, AiOutlinePlus, AiOutlineMinus,
  AiOutlineSearch, AiOutlineHome, AiOutlineSetting, AiOutlineLogout,
  AiOutlineBook, AiOutlineMail, AiOutlineMessage, AiOutlineCalendar,
  AiOutlineClockCircle, AiOutlineBell, AiOutlineStar, AiOutlineHeart,
  AiOutlineLike, AiOutlineDislike, AiOutlineShareAlt, AiOutlineCopy,
  AiOutlineSave, AiOutlineFile, AiOutlineFolder, AiOutlinePicture,
  AiOutlineVideoCamera, AiOutlineSound, AiOutlinePrinter,
  AiOutlineDownload, AiOutlineUpload, AiOutlineEye, AiOutlineEyeInvisible,
  AiOutlineLock, AiOutlineUnlock, AiOutlineKey, AiOutlineWifi,
  AiOutlineMobile, AiOutlineTablet, AiOutlineDesktop,
  AiOutlineDatabase, AiOutlineCloudServer
} from 'react-icons/ai';
// Bootstrap Icons (Bs)
import {
  BsPencil, BsTrash, BsArrowClockwise, BsXCircle, BsCheckCircle,
  BsPlus, BsDash, BsPerson, BsPeople, BsGear, BsBoxArrowRight,
  BsHouse, BsSearch, BsFilter, BsDownload, BsUpload, BsEye, BsEyeSlash,
  BsLock, BsUnlock, BsEnvelope, BsBell, BsCalendar, BsClock,
  BsFileText, BsFolder, BsImage, BsPlayCircle, BsMusicNote
} from 'react-icons/bs';
// Heroicons (Hi)
import {
  HiOutlinePencil, HiOutlineTrash, HiOutlineRefresh, HiOutlineXCircle,
  HiOutlineCheckCircle, HiOutlinePlus, HiOutlineMinus, HiOutlineUser,
  HiOutlineUserGroup, HiOutlineCog, HiOutlineLogout, HiOutlineHome,
  HiOutlineSearch, HiOutlineDownload, HiOutlineUpload, HiOutlineEye,
  HiOutlineEyeOff, HiOutlineLockClosed, HiOutlineLockOpen,
  HiOutlineMail, HiOutlineBell, HiOutlineCalendar, HiOutlineClock
} from 'react-icons/hi';
// Ionicons (Io)
import {
  IoPencil, IoTrash, IoRefresh, IoCloseCircle, IoCheckmarkCircle,
  IoAdd, IoRemove, IoPerson, IoPeople, IoSettings, IoLogOut,
  IoHome, IoSearch, IoDownload, IoCloudUpload, IoEye, IoEyeOff,
  IoLockClosed, IoLockOpen, IoMail, IoNotifications, IoCalendar,
  IoTime, IoDocumentText, IoFolder, IoImage, IoVideocam, IoMusicalNote
} from 'react-icons/io5';
// Material Community Icons (Im)
import {
  ImPencil, ImBin, ImLoop2, ImCross, ImCheckmark,
  ImPlus, ImMinus, ImUser, ImUsers, ImCog, ImExit,
  ImHome, ImSearch, ImDownload, ImUpload, ImEye, ImEyeBlocked,
  ImLock, ImUnlocked, ImMail, ImBell, ImCalendar, ImClock
} from 'react-icons/im';

interface IconItem {
  name: string;
  component: any;
  library: string;
  category: string;
}

const IconTestPage: React.FC = () => {
  const [selectedLibrary, setSelectedLibrary] = useState<string>('all');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [copiedIcon, setCopiedIcon] = useState<string>('');

  // Organiser les icônes par catégorie
  const icons: IconItem[] = [
    // Actions principales
    { name: 'FiEdit2', component: FiEdit2, library: 'Feather', category: 'Actions' },
    { name: 'FiTrash2', component: FiTrash2, library: 'Feather', category: 'Actions' },
    { name: 'FiRefreshCw', component: FiRefreshCw, library: 'Feather', category: 'Actions' },
    { name: 'FiXCircle', component: FiXCircle, library: 'Feather', category: 'Actions' },
    { name: 'FiCheck', component: FiCheck, library: 'Feather', category: 'Actions' },
    { name: 'FiPlus', component: FiPlus, library: 'Feather', category: 'Actions' },
    { name: 'FiMinus', component: FiMinus, library: 'Feather', category: 'Actions' },
    { name: 'FiSave', component: FiSave, library: 'Feather', category: 'Actions' },
    { name: 'FiCopy', component: FiCopy, library: 'Feather', category: 'Actions' },
    { name: 'FiShare2', component: FiShare2, library: 'Feather', category: 'Actions' },
    { name: 'FiDownload', component: FiDownload, library: 'Feather', category: 'Actions' },
    { name: 'FiUpload', component: FiUpload, library: 'Feather', category: 'Actions' },
    
    // Utilisateurs et profil
    { name: 'FiUser', component: FiUser, library: 'Feather', category: 'Users' },
    { name: 'FiUsers', component: FiUsers, library: 'Feather', category: 'Users' },
    { name: 'FiSettings', component: FiSettings, library: 'Feather', category: 'Users' },
    { name: 'FiLogOut', component: FiLogOut, library: 'Feather', category: 'Users' },
    { name: 'FiLock', component: FiLock, library: 'Feather', category: 'Users' },
    { name: 'FiUnlock', component: FiUnlock, library: 'Feather', category: 'Users' },
    { name: 'FiKey', component: FiKey, library: 'Feather', category: 'Users' },
    
    // Navigation
    { name: 'FiHome', component: FiHome, library: 'Feather', category: 'Navigation' },
    { name: 'FiArrowLeft', component: FiArrowLeft, library: 'Feather', category: 'Navigation' },
    { name: 'FiArrowRight', component: FiArrowRight, library: 'Feather', category: 'Navigation' },
    { name: 'FiArrowUp', component: FiArrowUp, library: 'Feather', category: 'Navigation' },
    { name: 'FiArrowDown', component: FiArrowDown, library: 'Feather', category: 'Navigation' },
    { name: 'FiChevronLeft', component: FiChevronLeft, library: 'Feather', category: 'Navigation' },
    { name: 'FiChevronRight', component: FiChevronRight, library: 'Feather', category: 'Navigation' },
    { name: 'FiMenu', component: FiMenu, library: 'Feather', category: 'Navigation' },
    { name: 'FiX', component: FiX, library: 'Feather', category: 'Navigation' },
    
    // Communication
    { name: 'FiMail', component: FiMail, library: 'Feather', category: 'Communication' },
    { name: 'FiMessageCircle', component: FiMessageCircle, library: 'Feather', category: 'Communication' },
    { name: 'FiBell', component: FiBell, library: 'Feather', category: 'Communication' },
    { name: 'FiAtSign', component: FiAtSign, library: 'Feather', category: 'Communication' },
    
    // Documentation et fichiers
    { name: 'FiBook', component: FiBook, library: 'Feather', category: 'Files' },
    { name: 'FiFile', component: FiFile, library: 'Feather', category: 'Files' },
    { name: 'FiFolder', component: FiFolder, library: 'Feather', category: 'Files' },
    
    // Recherche et filtres
    { name: 'FiSearch', component: FiSearch, library: 'Feather', category: 'Search' },
    { name: 'FiFilter', component: FiFilter, library: 'Feather', category: 'Search' },
    
    // Visibilité
    { name: 'FiEye', component: FiEye, library: 'Feather', category: 'Visibility' },
    { name: 'FiEyeOff', component: FiEyeOff, library: 'Feather', category: 'Visibility' },
    
    // Dates et temps
    { name: 'FiCalendar', component: FiCalendar, library: 'Feather', category: 'Time' },
    { name: 'FiClock', component: FiClock, library: 'Feather', category: 'Time' },
    
    // Alertes et notifications
    { name: 'FiAlertCircle', component: FiAlertCircle, library: 'Feather', category: 'Alerts' },
    { name: 'FiAlertTriangle', component: FiAlertTriangle, library: 'Feather', category: 'Alerts' },
    { name: 'FiInfo', component: FiInfo, library: 'Feather', category: 'Alerts' },
    { name: 'FiHelpCircle', component: FiHelpCircle, library: 'Feather', category: 'Alerts' },
    { name: 'FiCheckCircle', component: FiCheckCircle, library: 'Feather', category: 'Alerts' },
    
    // Statistiques et graphiques
    { name: 'FiBarChart2', component: FiBarChart2, library: 'Feather', category: 'Charts' },
    { name: 'FiPieChart', component: FiPieChart, library: 'Feather', category: 'Charts' },
    { name: 'FiTrendingUp', component: FiTrendingUp, library: 'Feather', category: 'Charts' },
    { name: 'FiTrendingDown', component: FiTrendingDown, library: 'Feather', category: 'Charts' },
    { name: 'FiActivity', component: FiActivity, library: 'Feather', category: 'Charts' },
    
    // Argent et commerce
    { name: 'FiDollarSign', component: FiDollarSign, library: 'Feather', category: 'Commerce' },
    { name: 'FiCreditCard', component: FiCreditCard, library: 'Feather', category: 'Commerce' },
    { name: 'FiShoppingCart', component: FiShoppingCart, library: 'Feather', category: 'Commerce' },
    { name: 'FiShoppingBag', component: FiShoppingBag, library: 'Feather', category: 'Commerce' },
    { name: 'FiTag', component: FiTag, library: 'Feather', category: 'Commerce' },
    { name: 'FiPercent', component: FiPercent, library: 'Feather', category: 'Commerce' },
    
    // Récompenses
    { name: 'FiAward', component: FiAward, library: 'Feather', category: 'Awards' },
    { name: 'FiStar', component: FiStar, library: 'Feather', category: 'Awards' },
    { name: 'FiHeart', component: FiHeart, library: 'Feather', category: 'Awards' },
    { name: 'FiThumbsUp', component: FiThumbsUp, library: 'Feather', category: 'Awards' },
    { name: 'FiThumbsDown', component: FiThumbsDown, library: 'Feather', category: 'Awards' },
    
    // Localisation
    { name: 'FiMapPin', component: FiMapPin, library: 'Feather', category: 'Location' },
    { name: 'FiMap', component: FiMap, library: 'Feather', category: 'Location' },
    { name: 'FiNavigation', component: FiNavigation, library: 'Feather', category: 'Location' },
    { name: 'FiCompass', component: FiCompass, library: 'Feather', category: 'Location' },
    { name: 'FiGlobe', component: FiGlobe, library: 'Feather', category: 'Location' },
    
    // Technologie
    { name: 'FiLink', component: FiLink, library: 'Feather', category: 'Tech' },
    { name: 'FiExternalLink', component: FiExternalLink, library: 'Feather', category: 'Tech' },
    { name: 'FiWifi', component: FiWifi, library: 'Feather', category: 'Tech' },
    { name: 'FiSmartphone', component: FiSmartphone, library: 'Feather', category: 'Tech' },
    { name: 'FiTablet', component: FiTablet, library: 'Feather', category: 'Tech' },
    { name: 'FiMonitor', component: FiMonitor, library: 'Feather', category: 'Tech' },
    { name: 'FiServer', component: FiServer, library: 'Feather', category: 'Tech' },
    { name: 'FiDatabase', component: FiDatabase, library: 'Feather', category: 'Tech' },
    { name: 'FiCloud', component: FiCloud, library: 'Feather', category: 'Tech' },
    { name: 'FiCode', component: FiCode, library: 'Feather', category: 'Tech' },
    { name: 'FiTerminal', component: FiTerminal, library: 'Feather', category: 'Tech' },
    { name: 'FiGitBranch', component: FiGitBranch, library: 'Feather', category: 'Tech' },
    { name: 'FiZap', component: FiZap, library: 'Feather', category: 'Tech' },
    
    // Médias
    { name: 'FiImage', component: FiImage, library: 'Feather', category: 'Media' },
    { name: 'FiVideo', component: FiVideo, library: 'Feather', category: 'Media' },
    { name: 'FiMusic', component: FiMusic, library: 'Feather', category: 'Media' },
    { name: 'FiPrinter', component: FiPrinter, library: 'Feather', category: 'Media' },
    
    // Autres
    { name: 'FiTarget', component: FiTarget, library: 'Feather', category: 'Other' },
    { name: 'FiFlag', component: FiFlag, library: 'Feather', category: 'Other' },
    { name: 'FiHash', component: FiHash, library: 'Feather', category: 'Other' },
    { name: 'FiMoreHorizontal', component: FiMoreHorizontal, library: 'Feather', category: 'Other' },
    { name: 'FiMoreVertical', component: FiMoreVertical, library: 'Feather', category: 'Other' },
    
    // Font Awesome - Actions
    { name: 'FaEdit', component: FaEdit, library: 'Font Awesome', category: 'Actions' },
    { name: 'FaTrash', component: FaTrash, library: 'Font Awesome', category: 'Actions' },
    { name: 'FaPlus', component: FaPlus, library: 'Font Awesome', category: 'Actions' },
    { name: 'FaSave', component: FaSave, library: 'Font Awesome', category: 'Actions' },
    { name: 'FaCopy', component: FaCopy, library: 'Font Awesome', category: 'Actions' },
    { name: 'FaDownload', component: FaDownload, library: 'Font Awesome', category: 'Actions' },
    { name: 'FaUpload', component: FaUpload, library: 'Font Awesome', category: 'Actions' },
    
    // Material Design - Actions
    { name: 'MdEdit', component: MdEdit, library: 'Material', category: 'Actions' },
    { name: 'MdDelete', component: MdDelete, library: 'Material', category: 'Actions' },
    { name: 'MdAdd', component: MdAdd, library: 'Material', category: 'Actions' },
    { name: 'MdSave', component: MdSave, library: 'Material', category: 'Actions' },
    
    // Ant Design - Actions
    { name: 'AiOutlineEdit', component: AiOutlineEdit, library: 'Ant Design', category: 'Actions' },
    { name: 'AiOutlineDelete', component: AiOutlineDelete, library: 'Ant Design', category: 'Actions' },
    { name: 'AiOutlinePlus', component: AiOutlinePlus, library: 'Ant Design', category: 'Actions' },
    { name: 'AiOutlineSave', component: AiOutlineSave, library: 'Ant Design', category: 'Actions' },
    { name: 'AiOutlineCopy', component: AiOutlineCopy, library: 'Ant Design', category: 'Actions' },
    { name: 'AiOutlineDownload', component: AiOutlineDownload, library: 'Ant Design', category: 'Actions' },
    { name: 'AiOutlineUpload', component: AiOutlineUpload, library: 'Ant Design', category: 'Actions' },
    
    // Ant Design - Users
    { name: 'AiOutlineHome', component: AiOutlineHome, library: 'Ant Design', category: 'Navigation' },
    { name: 'AiOutlineSetting', component: AiOutlineSetting, library: 'Ant Design', category: 'Users' },
    { name: 'AiOutlineLogout', component: AiOutlineLogout, library: 'Ant Design', category: 'Users' },
    { name: 'AiOutlineEye', component: AiOutlineEye, library: 'Ant Design', category: 'Visibility' },
    { name: 'AiOutlineEyeInvisible', component: AiOutlineEyeInvisible, library: 'Ant Design', category: 'Visibility' },
    { name: 'AiOutlineLock', component: AiOutlineLock, library: 'Ant Design', category: 'Users' },
    { name: 'AiOutlineUnlock', component: AiOutlineUnlock, library: 'Ant Design', category: 'Users' },
    
    // Bootstrap Icons - Actions
    { name: 'BsPencil', component: BsPencil, library: 'Bootstrap', category: 'Actions' },
    { name: 'BsTrash', component: BsTrash, library: 'Bootstrap', category: 'Actions' },
    { name: 'BsArrowClockwise', component: BsArrowClockwise, library: 'Bootstrap', category: 'Actions' },
    { name: 'BsXCircle', component: BsXCircle, library: 'Bootstrap', category: 'Actions' },
    { name: 'BsCheckCircle', component: BsCheckCircle, library: 'Bootstrap', category: 'Actions' },
    { name: 'BsPlus', component: BsPlus, library: 'Bootstrap', category: 'Actions' },
    { name: 'BsDownload', component: BsDownload, library: 'Bootstrap', category: 'Actions' },
    { name: 'BsUpload', component: BsUpload, library: 'Bootstrap', category: 'Actions' },
    
    // Bootstrap Icons - Users
    { name: 'BsPerson', component: BsPerson, library: 'Bootstrap', category: 'Users' },
    { name: 'BsPeople', component: BsPeople, library: 'Bootstrap', category: 'Users' },
    { name: 'BsGear', component: BsGear, library: 'Bootstrap', category: 'Users' },
    { name: 'BsBoxArrowRight', component: BsBoxArrowRight, library: 'Bootstrap', category: 'Users' },
    { name: 'BsHouse', component: BsHouse, library: 'Bootstrap', category: 'Navigation' },
    
    // Heroicons - Actions
    { name: 'HiOutlinePencil', component: HiOutlinePencil, library: 'Heroicons', category: 'Actions' },
    { name: 'HiOutlineTrash', component: HiOutlineTrash, library: 'Heroicons', category: 'Actions' },
    { name: 'HiOutlineRefresh', component: HiOutlineRefresh, library: 'Heroicons', category: 'Actions' },
    { name: 'HiOutlineXCircle', component: HiOutlineXCircle, library: 'Heroicons', category: 'Actions' },
    { name: 'HiOutlineCheckCircle', component: HiOutlineCheckCircle, library: 'Heroicons', category: 'Actions' },
    { name: 'HiOutlinePlus', component: HiOutlinePlus, library: 'Heroicons', category: 'Actions' },
    { name: 'HiOutlineDownload', component: HiOutlineDownload, library: 'Heroicons', category: 'Actions' },
    { name: 'HiOutlineUpload', component: HiOutlineUpload, library: 'Heroicons', category: 'Actions' },
    
    // Heroicons - Users
    { name: 'HiOutlineUser', component: HiOutlineUser, library: 'Heroicons', category: 'Users' },
    { name: 'HiOutlineUserGroup', component: HiOutlineUserGroup, library: 'Heroicons', category: 'Users' },
    { name: 'HiOutlineCog', component: HiOutlineCog, library: 'Heroicons', category: 'Users' },
    { name: 'HiOutlineLogout', component: HiOutlineLogout, library: 'Heroicons', category: 'Users' },
    { name: 'HiOutlineHome', component: HiOutlineHome, library: 'Heroicons', category: 'Navigation' },
    { name: 'HiOutlineEye', component: HiOutlineEye, library: 'Heroicons', category: 'Visibility' },
    { name: 'HiOutlineEyeOff', component: HiOutlineEyeOff, library: 'Heroicons', category: 'Visibility' },
    { name: 'HiOutlineLockClosed', component: HiOutlineLockClosed, library: 'Heroicons', category: 'Users' },
    { name: 'HiOutlineLockOpen', component: HiOutlineLockOpen, library: 'Heroicons', category: 'Users' },
    
    // Ionicons - Actions
    { name: 'IoPencil', component: IoPencil, library: 'Ionicons', category: 'Actions' },
    { name: 'IoTrash', component: IoTrash, library: 'Ionicons', category: 'Actions' },
    { name: 'IoRefresh', component: IoRefresh, library: 'Ionicons', category: 'Actions' },
    { name: 'IoCloseCircle', component: IoCloseCircle, library: 'Ionicons', category: 'Actions' },
    { name: 'IoCheckmarkCircle', component: IoCheckmarkCircle, library: 'Ionicons', category: 'Actions' },
    { name: 'IoAdd', component: IoAdd, library: 'Ionicons', category: 'Actions' },
    { name: 'IoDownload', component: IoDownload, library: 'Ionicons', category: 'Actions' },
    { name: 'IoCloudUpload', component: IoCloudUpload, library: 'Ionicons', category: 'Actions' },
    
    // Ionicons - Users
    { name: 'IoPerson', component: IoPerson, library: 'Ionicons', category: 'Users' },
    { name: 'IoPeople', component: IoPeople, library: 'Ionicons', category: 'Users' },
    { name: 'IoSettings', component: IoSettings, library: 'Ionicons', category: 'Users' },
    { name: 'IoLogOut', component: IoLogOut, library: 'Ionicons', category: 'Users' },
    { name: 'IoHome', component: IoHome, library: 'Ionicons', category: 'Navigation' },
    { name: 'IoEye', component: IoEye, library: 'Ionicons', category: 'Visibility' },
    { name: 'IoEyeOff', component: IoEyeOff, library: 'Ionicons', category: 'Visibility' },
    { name: 'IoLockClosed', component: IoLockClosed, library: 'Ionicons', category: 'Users' },
    { name: 'IoLockOpen', component: IoLockOpen, library: 'Ionicons', category: 'Users' },
    
    // Material Community Icons - Actions
    { name: 'ImPencil', component: ImPencil, library: 'Material Community', category: 'Actions' },
    { name: 'ImBin', component: ImBin, library: 'Material Community', category: 'Actions' },
    { name: 'ImLoop2', component: ImLoop2, library: 'Material Community', category: 'Actions' },
    { name: 'ImCross', component: ImCross, library: 'Material Community', category: 'Actions' },
    { name: 'ImCheckmark', component: ImCheckmark, library: 'Material Community', category: 'Actions' },
    { name: 'ImPlus', component: ImPlus, library: 'Material Community', category: 'Actions' },
    { name: 'ImDownload', component: ImDownload, library: 'Material Community', category: 'Actions' },
    { name: 'ImUpload', component: ImUpload, library: 'Material Community', category: 'Actions' },
    
    // Material Community Icons - Users
    { name: 'ImUser', component: ImUser, library: 'Material Community', category: 'Users' },
    { name: 'ImUsers', component: ImUsers, library: 'Material Community', category: 'Users' },
    { name: 'ImCog', component: ImCog, library: 'Material Community', category: 'Users' },
    { name: 'ImExit', component: ImExit, library: 'Material Community', category: 'Users' },
    { name: 'ImHome', component: ImHome, library: 'Material Community', category: 'Navigation' },
    { name: 'ImEye', component: ImEye, library: 'Material Community', category: 'Visibility' },
    { name: 'ImEyeBlocked', component: ImEyeBlocked, library: 'Material Community', category: 'Visibility' },
    { name: 'ImLock', component: ImLock, library: 'Material Community', category: 'Users' },
    { name: 'ImUnlocked', component: ImUnlocked, library: 'Material Community', category: 'Users' },
  ];

  const filteredIcons = icons.filter(icon => {
    const matchesLibrary = selectedLibrary === 'all' || icon.library === selectedLibrary;
    const matchesCategory = selectedCategory === 'all' || icon.category === selectedCategory;
    const matchesSearch = icon.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesLibrary && matchesCategory && matchesSearch;
  });

  const categories = Array.from(new Set(icons.map(icon => icon.category))).sort();
  const libraries = Array.from(new Set(icons.map(icon => icon.library))).sort();

  const copyToClipboard = (iconName: string, library: string) => {
    let importPath = '';
    if (library === 'Feather') {
      importPath = `from 'react-icons/fi';`;
    } else if (library === 'Font Awesome') {
      importPath = `from 'react-icons/fa';`;
    } else if (library === 'Material') {
      importPath = `from 'react-icons/md';`;
    } else if (library === 'Ant Design') {
      importPath = `from 'react-icons/ai';`;
    } else if (library === 'Bootstrap') {
      importPath = `from 'react-icons/bs';`;
    } else if (library === 'Heroicons') {
      importPath = `from 'react-icons/hi';`;
    } else if (library === 'Ionicons') {
      importPath = `from 'react-icons/io5';`;
    } else if (library === 'Material Community') {
      importPath = `from 'react-icons/im';`;
    }
    
    const code = `import { ${iconName} } ${importPath}`;
    navigator.clipboard.writeText(code);
    setCopiedIcon(iconName);
    setTimeout(() => setCopiedIcon(''), 2000);
  };

  return (
    <div style={{
      padding: '20px',
      maxWidth: '1400px',
      margin: '0 auto',
      fontFamily: 'Cairo, Arial, sans-serif',
      direction: 'rtl'
    }}>
      <h1 style={{ fontSize: '32px', marginBottom: '30px', color: '#1f2937', textAlign: 'center' }}>
        🎨 معرض الأيقونات - Icon Gallery
      </h1>

      {/* Filtres */}
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '30px',
        display: 'flex',
        gap: '15px',
        flexWrap: 'wrap',
        alignItems: 'center'
      }}>
        <div style={{ flex: '1', minWidth: '200px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#374151' }}>
            🔍 البحث:
          </label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="ابحث عن أيقونة..."
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          />
        </div>
        
        <div style={{ minWidth: '150px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#374151' }}>
            📚 المكتبة:
          </label>
          <select
            value={selectedLibrary}
            onChange={(e) => setSelectedLibrary(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          >
            <option value="all">الكل</option>
            {libraries.map(lib => (
              <option key={lib} value={lib}>{lib}</option>
            ))}
          </select>
        </div>

        <div style={{ minWidth: '150px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#374151' }}>
            📁 الفئة:
          </label>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          >
            <option value="all">الكل</option>
            {categories.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Statistiques */}
      <div style={{
        backgroundColor: '#f3f4f6',
        padding: '15px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#6b7280'
      }}>
        عرض <strong>{filteredIcons.length}</strong> من أصل <strong>{icons.length}</strong> أيقونة
      </div>

      {/* Grille d'icônes */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: '15px'
      }}>
        {filteredIcons.map((icon) => {
          const IconComponent = icon.component as any;
          return (
            <div
              key={`${icon.library}-${icon.name}`}
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '12px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                border: copiedIcon === icon.name ? '2px solid #10b981' : '1px solid #e5e7eb'
              }}
              onClick={() => copyToClipboard(icon.name, icon.library)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
              }}
            >
              <div style={{ fontSize: '32px', marginBottom: '10px', color: '#3b82f6' }}>
                <IconComponent />
              </div>
              <div style={{
                fontSize: '12px',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '5px',
                wordBreak: 'break-word'
              }}>
                {icon.name}
              </div>
              <div style={{
                fontSize: '11px',
                color: '#6b7280',
                marginBottom: '5px'
              }}>
                {icon.library}
              </div>
              <div style={{
                fontSize: '10px',
                color: '#9ca3af',
                backgroundColor: '#f3f4f6',
                padding: '2px 6px',
                borderRadius: '4px',
                display: 'inline-block'
              }}>
                {icon.category}
              </div>
              {copiedIcon === icon.name && (
                <div style={{
                  marginTop: '8px',
                  fontSize: '11px',
                  color: '#10b981',
                  fontWeight: '600'
                }}>
                  ✓ تم النسخ!
                </div>
              )}
            </div>
          );
        })}
      </div>

      {filteredIcons.length === 0 && (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          color: '#6b7280',
          fontSize: '18px'
        }}>
          لا توجد أيقونات تطابق البحث
        </div>
      )}

      {/* Instructions */}
      <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '12px',
        marginTop: '30px',
        border: '1px solid #bfdbfe'
      }}>
        <h3 style={{ marginTop: 0, color: '#1e40af', marginBottom: '15px' }}>
          💡 تعليمات الاستخدام:
        </h3>
        <ul style={{ margin: 0, paddingRight: '20px', color: '#1e3a8a', lineHeight: '1.8' }}>
          <li>انقر على أي أيقونة لنسخ كود الاستيراد</li>
          <li>استخدم حقل البحث للعثور على أيقونات محددة</li>
          <li>فلتر حسب المكتبة (Feather, Font Awesome, Material Design, etc.)</li>
          <li>فلتر حسب الفئة (Actions, Navigation, Users, etc.)</li>
          <li>الأيقونات من Feather Icons (Fi) موصى بها للاستخدام</li>
        </ul>
        <div style={{ marginTop: '15px', padding: '15px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
          <h4 style={{ marginTop: 0, color: '#1e40af', marginBottom: '10px' }}>📚 المكتبات المتوفرة في react-icons:</h4>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', fontSize: '13px', color: '#1e3a8a' }}>
            <div>• <strong>Feather Icons</strong> (Fi) - ⭐ موصى به - تصميم عصري ونظيف</div>
            <div>• <strong>Font Awesome</strong> (Fa) - شائع جداً - آلاف الأيقونات</div>
            <div>• <strong>Material Design</strong> (Md) - تصميم Google Material</div>
            <div>• <strong>Ant Design</strong> (Ai) - تصميم Ant Design</div>
            <div>• <strong>Bootstrap Icons</strong> (Bs) - Bootstrap Official</div>
            <div>• <strong>Heroicons</strong> (Hi) - تصميم حديث من Tailwind</div>
            <div>• <strong>Ionicons</strong> (Io) - Ionic Framework</div>
            <div>• <strong>Material Community</strong> (Im) - Material Community Icons</div>
          </div>
          <p style={{ marginTop: '10px', marginBottom: 0, fontSize: '12px', color: '#64748b' }}>
            💡 للمزيد من الأيقونات، راجع: <a href="https://react-icons.github.io/react-icons/" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6' }}>react-icons.github.io</a>
          </p>
          <p style={{ marginTop: '8px', marginBottom: 0, fontSize: '12px', color: '#64748b' }}>
            📦 react-icons يحتوي على أكثر من <strong>30 مجموعة أيقونات</strong> مع آلاف الأيقونات المتاحة!
          </p>
        </div>
      </div>
    </div>
  );
};

export default IconTestPage;

